import axios from 'axios';
import { ANNOUNCEMENT_LIST } from '../../constants';
import { isSuperAdmin } from '../../../utils/appUtils';
import moment from 'moment-timezone';

export const fetchAnnouncementList =
  (search, visibleOn, onError) => (dispatch) => {
    const token = localStorage.jwtToken;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    dispatch(loadAnnouncementList());
    const url = isSuperAdmin()
      ? `/admin/listAnnouncement?searchString=${search}&currentDate=${new Date()}&timeZone=${moment.tz.guess()}`
      : `/admin/listAnnouncement?searchString=${search}&visibleOn=${visibleOn}&currentDate=${new Date()}&timeZone=${moment.tz.guess()}`;

    axios
      .get(url, config)
      .then((res) => dispatch(setAnnouncementList(res)))
      .catch((err) => {
        dispatch(errorAnnouncementList(err.response));
        onError(err.response);
      });
  };

export const loadAnnouncementList = () => ({
  type: ANNOUNCEMENT_LIST.LOAD,
});

export const setAnnouncementList = (announcementList) => ({
  type: ANNOUNCEMENT_LIST.SUCCESS,
  payload: announcementList.data.data,
});

export const errorAnnouncementList = (error) => ({
  type: ANNOUNCEMENT_LIST.FAIL,
  payload: error,
});
